export function getApiErrorMessage(error, fallback = "Request failed") {
  if (!error) return fallback;

  if (Array.isArray(error.validationError) && error.validationError.length > 0) {
    return error.validationError.join(", ");
  }

  if (error.errors && typeof error.errors === "object") {
    const fieldErrors = Object.values(error.errors).filter(Boolean);
    if (fieldErrors.length > 0) {
      return fieldErrors.join(", ");
    }
  }

  return (
    error.message ||
    error.businessExceptionDescription ||
    fallback
  );
}

export function isApiStatus(error, status) {
  return error?.status === status;
}